export enum ExamTypeEnum {
    edit = 'edit',
    delete = 'delete',
}
